import { Box, InputBoxed, Typography, Flex, ButtonSecondary } from '@creditas-ui/react';
import { useNavigateForm } from '@/shared/application/hooks/useNavigateForm';
import { useRecoveryForm } from '@/auth/application/hooks/useRecoveryForm';
import { useForm, usePageView } from '@/shared/application/hooks';
import { ContinueButton } from '@/shared/ui';
import { Logo } from '@/shared/ui/Logo';
import * as S from './login.styles';

const Recovery = (): JSX.Element => {
  usePageView();
  const { goToLogin, goToSignup } = useNavigateForm();
  const { form, loading } = useRecoveryForm({
    useForm,
  });

  return (
    <S.Wrapper>
      <S.LoginLogoSection>
        <Logo />
        <Typography
          variant="headingLgLight"
          color="neutral.90"
          style={{ paddingBottom: '5px', marginTop: '40px' }}
        >
          Recuperar senha
        </Typography>
        <Typography variant="bodyMdRegular" color="neutral.60">
          Insira o endereço de email associado à sua conta que lhe enviaremos um link de redefinição
          de senha.
        </Typography>
        <S.Form name="recovery" style={{ width: '100%' }} onSubmit={form.handleSubmit}>
          <Box mb="24px">
            <InputBoxed
              label="E-mail"
              autoComplete="off"
              type="email"
              name="email"
              value={form.values.email}
              data-testid="email"
              onChange={form.handleChange}
              onBlur={form.handleBlur}
              error={String(form.touched.email && form.errors.email ? form.errors.email : '')}
            />
          </Box>
          <Box alignItems="stretch">
            <ContinueButton
              loading={loading}
              disabled={loading || !form.isValid}
              text="Enviar link de redefinição"
            />
            <Flex justifyContent="center" mt="24px">
              <ButtonSecondary
                type="button"
                onClick={goToSignup}
                disabled={loading}
                data-testid="backButton"
              >
                Quero me cadastrar
              </ButtonSecondary>
            </Flex>
            <Flex justifyContent="center" mt="24px">
              <ButtonSecondary
                type="button"
                onClick={goToLogin}
                disabled={loading}
                data-testid="backButton"
              >
                Voltar para o login
              </ButtonSecondary>
            </Flex>
          </Box>
        </S.Form>
      </S.LoginLogoSection>
    </S.Wrapper>
  );
};

export { Recovery };
